import React from 'react';
import PropTypes from 'prop-types';

import EmptyAvatar from '../../assets/images/emptyAvatar.png';
import Text from '../Text/Text';
import { ReactComponent as IconPencil } from '../../assets/icon/ic_pencil.svg';
import { ReactComponent as IconLastic } from '../../assets/icon/ic_lastic.svg';

const ImagePicker = ({
  defaultImage, onImageChange, onClear, styleContainer, styleImageContainer, name
}) => {
  return (
    <div className={`flex flex-col items-center justify-center ${styleContainer}`}>
      <div className={`shadowDefault flex border-[3px] border-white rounded-[8px]
        w-[125px] h-[125px] mb-[5px] relative ${styleImageContainer}`}
      >
        <img src={defaultImage || EmptyAvatar} alt="avatar" className="w-full h-full rounded-[8px]" />
        <label htmlFor={name} className="absolute top-[-9px] right-[-9px]">
          <div
            className="cursor-pointer flex justify-center items-center p-[5px] bg-white rounded-full shadowDefault
            hover:text-primary"
          >
            <IconPencil className="w-[15px] h-[15px] text-text-muted" />
          </div>
          <input
            type="file"
            className="w-0 h-0 overflow-hidden opacity-0"
            name={name}
            accept=".png, .jpg, .jpeg"
            id={name}
            onChange={onImageChange}
          />
        </label>
        {onClear && (
          <div
            className="cursor-pointer flex justify-center items-center p-[5px] bg-white rounded-full shadowDefault
            absolute bottom-[-9px] right-[-9px] hover:text-primary"
            onClick={onClear}
            role="presentation"
          >
            <IconLastic className="w-[15px] h-[15px] text-text-muted" />
          </div>
        )}
      </div>
      <Text
        muted
        text="Only *.png, *.jpg and *.jpeg image files are accepted"
        textStyle="font-[200] text-[11px]"
      />
    </div>
  );
};

ImagePicker.propTypes = {
  defaultImage: PropTypes.string,
  styleContainer: PropTypes.string,
  styleImageContainer: PropTypes.string,
  name: PropTypes.string,
  onImageChange: PropTypes.func,
  onClear: PropTypes.func
};

ImagePicker.defaultProps = {
  defaultImage: undefined,
  styleContainer: '',
  styleImageContainer: '',
  name: 'file',
  onImageChange: () => {},
  onClear: undefined
};

export default ImagePicker;
